import PropTypes from 'prop-types';
import { Component } from 'react';

import { Button as DSButton } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import { NotifyPeopleTriggerButton } from 'hb-react/frontoffice/components/NotifyPeopleModal/NotifyPeopleTriggerButton';

import UserTargeting from '.';

class Button extends Component {
  state = { totalSelectedUsers: 0 };

  updateTotalSelectedUsers = (selectedUserIds) => {
    const { displayTotalSelectedUsers } = this.props;

    if (displayTotalSelectedUsers) {
      this.setState({
        totalSelectedUsers: selectedUserIds.length,
      });
    }
  };

  render() {
    const { title, displayTotalSelectedUsers, disabled, userTargetingProps } =
      this.props;
    const { totalSelectedUsers } = this.state;

    const { onValidateSelection } = userTargetingProps;
    const newUserTargetingProps = {
      ...userTargetingProps,
      ...{
        onValidateSelection: (selectedUsers, selectedUserIds) => {
          this.updateTotalSelectedUsers(selectedUserIds);
          if (onValidateSelection) {
            onValidateSelection(selectedUserIds);
          }
        },
        onCancelSelection: () => {
          this.updateTotalSelectedUsers([]);
          if (onValidateSelection) {
            onValidateSelection([]);
          }
        },
      },
    };

    return (
      <div className="flexbox">
        {displayTotalSelectedUsers && totalSelectedUsers > 0 && (
          <div className="flexbox__item">
            <div id="notify_users_count">
              {I18n.t('web.targeting_module.people_reached', {
                count: totalSelectedUsers,
                total: totalSelectedUsers,
              })}
            </div>
          </div>
        )}

        <div className="flexbox__item">
          <UserTargeting
            renderTriggerElement={(onClick) => (
              <NotifyPeopleTriggerButton ml={6} onClick={onClick} />
            )}
            openByClickOn={
              <DSButton
                dataTestId="user-targeting-button"
                isDisabled={disabled}
                icon={() => (
                  <FontAwesomeIcon
                    iconName="bell"
                    height="16px"
                    iconType={CATEGORIES.SOLID}
                  />
                )}
                ml={6}
                variant="secondary"
              >
                {title || I18n.t('web.targeting_module.target_people')}
              </DSButton>
            }
            {...newUserTargetingProps}
          />
        </div>
      </div>
    );
  }
}

Button.propTypes = {
  title: PropTypes.string,
  displayTotalSelectedUsers: PropTypes.bool,
  userTargetingProps: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  displayTotalSelectedUsers: false,
  disabled: false,
};

export default Button;
